import useTranslation from 'next-translate/useTranslation';

import Autor from '@/assets/icons/Autor.svg';
import Calendar from '@/assets/icons/Calendar.svg';
import Time from '@/assets/icons/Tiempo.svg';

import type { FunctionComponent } from 'react';
import type { TypeCharacteristicsPostsProps } from './types';

/**
 * CharacteristicsPosts
 */
export const CharacteristicsPosts: FunctionComponent<
  TypeCharacteristicsPostsProps
> = ({
  className = '',
  author,
  averageTimeToRead,
  postDate,
}: TypeCharacteristicsPostsProps) => {
  const { t, lang } = useTranslation('common');

  return (
    <div className={`inline-flex flex-row flex-wrap gap-2 italic ${className}`}>
      <div className="flex flex-row items-center gap-1">
        <Calendar width={20} height={20} />
        <span>{new Intl.DateTimeFormat(lang).format(postDate)}</span>
      </div>

      <div className="block border-l border-primary-200" />

      <div className="flex flex-row items-center gap-1">
        <Autor width={20} height={20} />
        <span>{author}</span>
      </div>

      <div className="block border-l border-primary-200" />

      <div className="flex flex-row items-center gap-1">
        <Time width={20} height={20} />
        <span>
          {averageTimeToRead}{' '}
          {t('components.atoms.characteristicsPost.averageReading')}
        </span>
      </div>
    </div>
  );
};

CharacteristicsPosts.displayName = 'CharacteristicsPosts';
